import React, { useEffect, useState } from 'react';
import PageContainer from '../../layouts/PageContainer';
import StarterPanel from '../../components/Dashboard/StarterPanel';
import NewVoucher from '../../components/Voucher/NewVoucher';
import { useMySale } from '../../DataStore/MySaleContext';
import RecentVoucher from '../../components/Vendor/RecentVoucher';
import { numberFormat } from '../../util/araknerdlib';
import { useAuth } from '../../DataStore/AuthContext';

const VendorPage = () => {
  const [showManual, setShowManual] = useState(false);
  const {getRecentVouchers, recentVouchers, getStats, stats} = useMySale();
  const {connectedProfiles} = useAuth();


  useEffect(()=>{
    getRecentVouchers();
    getStats();
  }, [])

  const onRefresh = () => {
    getRecentVouchers(true);
    getStats(true);
  };

  const money = (v) =>  connectedProfiles?.currency + ' ' + new Intl.NumberFormat('en-UG').format(v);

  const StatCard = ({ title, value, sub, icon, tone }) => (
    <div className="col-6 mb-3">
      <div className={`of-card of-stat of-${tone}`}>
        <div className="of-stat-top">
          <div className="of-stat-ico">
            <i className={`fas ${icon}`} />
          </div>
          <div className="of-stat-meta">
            <div className="of-stat-title">{title}</div>
            <div className="of-stat-sub">{sub}</div>
          </div>
        </div>

        <div className="of-stat-value">{value}</div>
      </div>
    </div>
  );

  return (<>
    <PageContainer>

      <div className="row">
        <StarterPanel />
      </div>

      {/* Dashboard strip */}
      <div className="row">
        <div className="col-12 mb-3">
          <div className="of-card of-header">
            <div>
              <div className="of-header-title">Vendor Dashboard</div>
              <div className="of-header-sub">Sales overview</div>
            </div>
            {/* <button
              type="button"
              className="btn btn-rounded btn-success"
              onClick={() => setShowManual(true)}
            >
              <i className="fas fa-plus mr-2" />
              New Voucher
            </button> */}
            <div className="btn-icon-list">
              <button className="btn ripple btn-success btn-icon" title='New Voucher' onClick={() => setShowManual(true)}><i className="fe fe-plus"></i></button>
              <button className="btn ripple btn-secondary btn-icon" title='Refresh' onClick={onRefresh}><i className="fe fe-refresh-cw"></i></button>
            </div>
          </div>
        </div>
      </div>

      {/* Stats (2x2 on mobile) */}
      <div className="row row-sm">
        <StatCard
          title="Daily Vouchers"
          value={numberFormat(stats?.total_daily_vouchers_sold || '00')}
          sub="Total vouchers today"
          icon="fa-ticket-alt"
          tone="mint"
        />
        <StatCard
          title="Monthly Vouchers"
          value={numberFormat(stats?.total_monthly_vouchers_sold || '00')}
          sub="Total vouchers this month"
          icon="fa-calendar-alt"
          tone="sky"
        />
        <StatCard
          title="Float Balance"
          value={money(stats?.float_balance || 0)}
          sub="Voucher Coin Balance"
          icon="fa-coins"
          tone="violet"
        />
        <StatCard
          title="Monthly Revenue"
          value={money(stats?.total_revenue_this_month || 0)}
          sub="Voucher Sales"
          icon="fa-chart-line"
          tone="amber"
        />
      </div>

      {/* Recent vouchers */}
      <div className="row">
        <div className="col-12">
         <RecentVoucher recentSales={recentVouchers} currency={connectedProfiles?.currency} />

          <div style={{ height: 16 }} />
        </div>
      </div>
    </PageContainer>

    <NewVoucher
      show={showManual}
      onClose={() => setShowManual(false)}
      onSuccess={() => {
            setShowManual(false);
            onRefresh();
        }}
        title="New Voucher"
      vendor={true}
    />
    </>
  );
};

export default VendorPage;
